
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSEO, generateWebPageSchema } from '../../utils/seo';
import ComparisonNavbar from './components/ComparisonNavbar';
import ComparisonHero from './components/ComparisonHero';
import PlanCards from './components/PlanCards';
import ComparisonTable from './components/ComparisonTable';
import ComparisonCTA from './components/ComparisonCTA';
import ComparisonFooter from './components/ComparisonFooter';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

export default function ComparacaoPage() {
  const [scrolled, setScrolled] = useState(false);

  // SEO Configuration
  useSEO({
    title: 'Comparação de Planos - Start vs Scale | NeuroAgents',
    description: 'Compare os planos Start (R$ 197/mês) e Scale (R$ 297/mês) da NeuroAgents. Veja todas as funcionalidades, integrações e recursos de cada plano para escolher o ideal para seu negócio.',
    keywords: 'planos neuroagents, comparação planos IA, preço automação whatsapp, plano start scale, quanto custa chatbot IA',
    canonical: '/comparar-planos',
    type: 'website',
    jsonLd: generateWebPageSchema({
      name: 'Comparação de Planos NeuroAgents',
      description: 'Compare os planos Start e Scale e escolha o melhor para seu negócio',
      url: '/comparar-planos',
    }),
  });

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <ComparisonNavbar scrolled={scrolled} />
      <ComparisonHero />
      <PlanCards />
      <ComparisonTable />
      <ComparisonCTA />
      <ComparisonFooter />
      <WhatsAppButton />
    </div>
  );
}
